import { useState } from 'react';

import {
  Icon,
  InputGroup,
  InputGroupAddon,
  InputGroupButton,
  InputGroupInput,
} from '@eluve/components';

/**
 * Read-only settings value with an edit affordance: an input group showing
 * the current value with a trailing icon-only edit button that opens the
 * editing dialog supplied via `renderDialog`.
 */
export const SettingsEditableValue = ({
  value,
  editLabel,
  renderDialog,
}: {
  value: string;
  /** Accessible label for the edit button, e.g. "Edit full name". */
  editLabel: string;
  renderDialog: (props: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  }) => React.ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <InputGroup className="bg-bg-primary">
        <InputGroupInput value={value} readOnly />
        <InputGroupAddon align="inline-end">
          <InputGroupButton
            aria-label={editLabel}
            onClick={() => setOpen(true)}
            size="sm"
          >
            <Icon name="Pencil" size="auto" />
          </InputGroupButton>
        </InputGroupAddon>
      </InputGroup>
      {renderDialog({ open, onOpenChange: setOpen })}
    </>
  );
};
